import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Cache from '@/helper/Cache.js'
import Account from '@/helper/AccountHelper.js'

/**
 * @method getPoint
 * @method getCustomerStore
 * @method getProfile
 * @method getCampaign
 * @method getUserExpriedPoint
 * @method getUserExpriedPointHistory
 */

export default {
  config: function () {
    return Vue.bzbsConfig
  },
  token: function () {
    return Account.getCacheToken() ? Account.getCacheToken() : null
  },
  tokenCRMUser: function () {
    return Account.getCacheToken() ? Account.getCacheToken() : null
  },
  ewallet_token: function () {
    return Account.getCacheWalletToken() ? Account.getCacheWalletToken() : null
  },
  app_id: function () {
    if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
      if (
        Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId !=
        undefined
      ) {
        return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId
      } else {
        return Account.getCacheCustom('app_id')
      }
    } else {
      return Account.getCacheCustom('app_id')
    }
  },
  agency_id: function () {
    return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).sponsorId
  },
  user_id: function () {
    return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).userId
  },
  getPoint: function () {
    var strUrl =
      this.config().bzbEwalletUrl +
      '/earn/code?device_app_id=' +
      this.app_id() +
      '&agencyId=' +
      this.agency_id() +
      '&mac_address='
    return BzbsApi.connectBzbsGet(strUrl, this.ewallet_token(), null)
  },
  getCustomerStore: function () {
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmpluscustomer/store?device_app_id=' +
      this.app_id()
    return BzbsApi.connectBzbsGet(strUrl, null, null)
  },
  getProfile: function () {
    var strUrl =
      this.config().bzbUrlService + '/profile/me?device_app_id=' + this.app_id()
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  getCampaign: function (params) {
    var strUrl =
      this.config().bzbUrlService +
      '/campaign?device_app_id=' +
      this.app_id() +
      '&byConfig=true' +
      '&config=' +
      params.campaign +
      '&top=' +
      params.top +
      '&skip=' +
      params.skip
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  getUserExpriedPoint: function () {
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmpluscustomer/get_userexpiringpointlists?userId=' +
      this.user_id() +
      '&appId=' +
      this.app_id()
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  getUserExpriedPointHistory: function (params) {
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmpluscustomer/get_userexpiredpointlists?userId=' +
      this.user_id() +
      '&appId=' +
      this.app_id() +
      '&year=' +
      params.year
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  getUserLevel: function (param) {
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmpluscustomer/userlevel?userId=' +
      this.user_id() +
      '&appId=' +
      this.app_id() +
      '&levelname=' +
      param
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  getUserLevelList: function () {
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/userlevel'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  getUserLevelByName: function () {
    let params = {
      levelname: 'Silver',
    }
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/userlevel'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), params)
  },
  getActiveFGF() {
    const params = {
      device_app_id: this.app_id(),
      agencyId: this.agency_id(),
    }
    var strUrl = this.config().bzbModuleUrl + '/crmplusfriendgetfriend/detail'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), params)
  },
  getFGFGenLink() {
    const params = {
      device_app_id: this.app_id(),
      agencyId: this.agency_id(),
    }
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmplusfriendgetfriend/get_info_invite_to_line'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), params)
  },
  getListFGF() {
    const params = {
      device_app_id: this.app_id(),
      agencyId: this.agency_id(),
    }
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmplusfriendgetfriend/list_merge_referral_user'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), params)
  },
  getloginmission() {
    const params = {
      device_app_id: this.app_id(),
      group: 'login',
    }
    var strUrl = this.config().bzbUrlService + '/profile/me/badges'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), params)
  },
  getblobearncode() {
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmpluscustomer/get_survey_campaign?v=' +
      new Date().getTime()
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
}
